import { Layout } from 'components/layout'
import { useLoadInitialData } from 'hooks/database/use-load-initial-data'
import { useRef } from 'react'
import toast from 'react-hot-toast'
import { Button } from 'ui-kit/button'
import { Textarea } from 'ui-kit/textarea'
import { TextInput } from 'ui-kit/textInput'

import { urlWithSiteOrigin } from '../../utils/url-with-site-origin'
import { ContactUsData, sendContactInfoToAdmin } from './api'
import { ButtonWrapper, Container, Form } from './contact-us.styles'

export const ContactUs = () => {
  useLoadInitialData()
  const formRef = useRef<HTMLFormElement>(null)

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    const data = Object.fromEntries(formData)

    try {
      await sendContactInfoToAdmin(data as ContactUsData)
      toast.success('Message sent successfully. We will get back to you soon via email.')
      // Clear the form after successful submission
      formRef.current?.reset()
    } catch (error) {
      console.error('Failed to send contact info to admin:', error)
      toast.error('Failed to send message')
    }
  }

  return (
    <Layout
      seoProps={{
        title: 'Contact us for any query. Also write if you have suggestions.',
        description:
          'Let us know what you think about TypingMentor or if you have suggestions about the features and functionalities of TypingMentor',
        canonicalUrl: urlWithSiteOrigin('/contact-us/'),
        pageUrl: urlWithSiteOrigin('/contact-us/'),
      }}
    >
      <Container>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <h1>Stay in touch!</h1>
          <p style={{ margin: '-20px 0 2rem 0' }}>We typically respond to messages within 24 hours via email.</p>
          <TextInput name="name" required wrapperClass="contact-us-input" type="text" placeholder="Name" />
          <TextInput name="email" required wrapperClass="contact-us-input" type="email" placeholder="Email" />
          <TextInput name="subject" required wrapperClass="contact-us-input" type="text" placeholder="Subject" />
          <Textarea name="message" placeholder="Message" required className="contact-us-textarea" />
          <ButtonWrapper>
            <Button type="submit" className="contact-us-button">
              Submit
            </Button>
          </ButtonWrapper>
        </Form>
      </Container>
    </Layout>
  )
}
